/**
 * The read-only identity pair above the edit-profile form: the avatar and the
 * display name. The display name is server-derived from the first and last
 * name, so it is shown, not typed (see `## 0` cut 2 in ISSUE-487's plan).
 * The avatar is NOT here. It moved to `EditProfilePhotoField` in the same
 * folder when the upload control shipped, so one component owns the photo.
 * The email row is NOT here. It renders last, after `Phone number`, through
 * `EmailBlock` and `EditProfileFields`'s `emailSlot` prop, because the design
 * frame draws `Email` as the last field. See decisions D-9 and D-10.
 */
import type { ReactNode } from "react";

import { DISPLAY_NAME_LABEL, DISPLAY_NAME_NOTE } from "./editProfileLogic";

export const IdentityBlock = ({
  displayName,
}: {
  displayName: string;
}): ReactNode => {
  return (
    <>
      <div
        data-testid="edit-profile-display-name"
        className="flex flex-col gap-1"
      >
        <span className="text-caption text-ink-tertiary">
          {DISPLAY_NAME_LABEL}
        </span>
        <span className="text-body-strong text-ink">{displayName}</span>
        <span className="text-caption text-ink-secondary">
          {DISPLAY_NAME_NOTE}
        </span>
      </div>
    </>
  );
};
